import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

export default function ProtectedRoute({ children, roles }) {
    const { user, loading } = useAuth();
    if (loading)
        return (
            <div
                className="min-h-screen flex items-center justify-center"
                data-testid="auth-loading"
            >
                <Loader2 className="w-8 h-8 animate-spin text-teal-600" />
            </div>
        );
    if (!user) return <Navigate to="/login" replace />;
    if (roles && !roles.includes(user.role))
        return <Navigate to="/dashboard" replace />;
    return children;
}
